<template>
  <div id="root">
    <router-view/>
  </div>
</template>

<script>
import 'normalize.css'
import '@/styles/main.scss'

export default {
  name: 'App'
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/App.vue